import Vue from 'vue';
import VueSessionStorage from 'vue-sessionstorage';
import axios from 'axios';
import config from './_config';
Vue.use(VueSessionStorage);

//const session = Vue.prototype.$session;

export const HTTP = axios.create({
    baseURL: config.apiRoot,
    headers: {
        'Content-Type': 'application/json',
    },
});